import { keyframes, styled } from '@acko-tech/building-blocks.ui.common';

const shimmer = keyframes`
    0% { background-position: -220px 0; }
    100% { background-position: 220px 0; }
`;

export const HeaderCard = styled.div`
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 24px 0;

    @media screen and (max-width: 769px) {
        padding: 10px;
        gap: 10px;
    }

    .userDropdown {
        min-width: 200px;
        width: 200px;
    }

    @media screen and (max-width: 769px) {
        .userDropdown {
            min-width: 100%;
            width: 100%;
        }
    }
`;

export const DropdownRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 12px;

    @media screen and (max-width: 769px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        margin-bottom: 8px;
    }
`;

export const DealerLabel = styled.div`
    color: #5f5f73;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;

    @media screen and (max-width: 769px) {
        font-size: 12px;
        color: #a0a0af;
    }
`;

export const SummaryRow = styled.div`
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 28px;

    @media screen and (max-width: 769px) {
        flex-direction: column;
        gap: 16px;
    }
`;

export const DataSyncHint = styled.p`
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    color: #8c8c9b;
    font-weight: 400;

    @media screen and (max-width: 769px) {
        font-size: 12px;
        width: 100%;
    }
`;

export const SummaryCard = styled.div`
    flex: 1;
    border-radius: 10px;
    background: #faf9fd;
    padding: 40px 14px;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SummaryLabel = styled.div`
    color: #767386;
    font-size: 20px;
    font-weight: 500;
    text-align: left;
`;

export const SummaryValue = styled.div`
    color: #2f2e38;
    font-size: 28px;
    line-height: 38px;
    font-weight: 700;
    text-align: left;

    @media screen and (max-width: 769px) {
        font-size: 26px;
        line-height: 36px;
    }
`;

export const SummaryValueDeposits = styled(SummaryValue)`
    color: #0b7a6f;
`;

export const SummaryPeriodLabel = styled.div`
    color: #767386;
    font-size: 12px;
    font-weight: 500;
`;

export const MobileSummaryCard = styled.div`
    width: 100%;
    border-radius: 12px;
    background: #f5f4f9;
    padding: 12px;
    text-align: left;
`;

export const MobileMiniSummaryRow = styled.div`
    margin-top: 10px;
    display: flex;
    gap: 16px;
`;

export const MobileMiniSummaryCard = styled.div`
    flex: 1;
    border-radius: 8px;
    background: #ffffff;
    padding: 8px 10px;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const MobileMiniLabel = styled.div`
    color: #9b98a8;
    font-size: 12px;
    text-align: left;
`;

export const MobileMiniValue = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: #2f2e38;
    text-align: left;
`;

export const MobileMiniValueDeposits = styled(MobileMiniValue)`
    color: #0b7a6f;
`;

export const ValueSkeleton = styled.div`
    width: 160px;
    height: 28px;
    border-radius: 8px;
    background: linear-gradient(90deg, #f2f2f5 25%, #ececf2 50%, #f2f2f5 75%);
    background-size: 220px 100%;
    animation: ${shimmer} 1.2s infinite;
`;
